interface ConfigThemeDetailResource {
  path: string;
}

export interface ConfigThemeFontDefinition {
  src: string;
  family: string;
  weight: string;
  style?: string;
  display?: FontDisplay;
}

export interface ConfigThemeDetail {
  localResourcesSourceUrl: string,
  resources: ConfigThemeDetailResource[];
  fonts?: ConfigThemeFontDefinition[];
}

export interface ConfigTheme {
  [theme: string]: ConfigThemeDetail;
}

export interface Config {
  componenTagName: string;
  theme: ConfigTheme;
}

export const config : Config = {
  componenTagName: 'tef-coms4cs4p',
  theme: {
    occl: {
      localResourcesSourceUrl: 'https://dev-library.telefonica.de/1',
      fonts: [
        {
          src: '/fonts/OnAir-Regular.woff2', family: 'On Air', weight: '400', style: 'normal', display: 'swap',
        },
        {
          src: '/fonts/OnAir-Bold.woff2', family: 'On Air', weight: '700', style: 'normal', display: 'swap',
        },
      ],
      resources: [
        { path: '/v3/components/theme/bundle.css' },
        { path: '/v3/components/carousel/bundle.js' },
        { path: '/v3/components/multi-checkbox/bundle.js' },
        { path: '/v3/components/shop-switcher-dropdown/bundle.js' },
        { path: '/v3/components/icon/bundle.js' },
        { path: '/v3/components/alert/bundle.js' },
        { path: '/v3/components/toast/bundle.js' },
        { path: '/v3/library/vendors.js' },
      ],
    },
  },
};
